export default [
  ['activities', 'activity']
];
